import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2563e55b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=2563e55b&prod&scoped=true&lang=less"
import style1 from "./Home.vue?vue&type=style&index=1&id=2563e55b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563e55b",
  null
  
)

export default component.exports